// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
// import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
// import { AgGridReact } from "ag-grid-react"; // AG Grid Component
// import { ProductsAPI } from "api";
// import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
// import CardDropdown from "components/common/CardDropdown";
// import IconButton from "components/common/IconButton";
// import TableHeaderDropdown from "components/common/TableHeaderDropdown";
// import { settings } from "config";
// import { useFetchStores } from "hooks/useFetchStores";
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import {
//   Card,
//   Dropdown,
//   Form,
//   OverlayTrigger,
//   Spinner,
//   Tooltip,
// } from "react-bootstrap";
// import { MdOutlineModeEdit } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { CONSTANT_ROUTES } from "routes";
// import PageTitle from "utils/PageTitle";
// import {
//   resetColumnState,
//   restoreColumnState,
//   saveColumnState,
// } from "utils/tablesUtils";
// import "./styles.css";
// import ScreenFeedback from "components/feedback/ScreenFeedback";

// export default function ProductsTable() {
//   let isDarkBool = localStorage.getItem("isDark") === true;
//   let isDarkTheme = localStorage.getItem("theme") === "dark";
//   let auto = localStorage.getItem("theme") === "auto";
//   const navigate = useNavigate();
//   const columnApiRef = useRef();
//   const gridRef = useRef();
//   // let gridApi;

//   const [rowData, setRowData] = useState([
//     // { id: "1", type: "ABC", name: "Model Y" },
//   ]);
//   const [isLoading, setIsLoading] = useState(false);

//   // Column Definitions: Defines the columns to be displayed.
//   const [colDefs, setColDefs] = useState([
//     // { field: "", filter: false, headerName: "Select" },

//     {
//       field: "name",
//       headerName: "Name",
//       hide: false,
//       flex: 7.5,
//       cellStyle: {
//         whiteSpace: "nowrap",
//         textOverflow: "ellipsis",
//         overflow: "hidden",
//       },
//     },
//     {
//       field: "category",
//       headerName: "Category",
//       hide: false,
//       flex: 1.5,
//       cellStyle: {
//         whiteSpace: "nowrap",
//         textOverflow: "ellipsis",
//         overflow: "hidden",
//       },
//     },
//     {
//       field: "status",
//       headerName: "Active",
//       flex: 1.5,
//       filter: false,
//       sortable: true,
//       headerClass: "center-header",
//       cellStyle: {
//         display: "flex",
//         justifyContent: "center",
//       },
//       cellRenderer: (p) => (
//         <Form.Check
//           type="checkbox"
//           className="mt-1"
//           checked={p.value}
//           disabled
//         />
//       ),
//     },
//     {
//       headerName: "Action",
//       field: "action",
//       flex: 1.5,
//       filter: false,

//       headerClass: "center-header",
//       cellStyle: {
//         display: "flex",
//         // paddingRight: "30px",
//         justifyContent: "center",
//       },
//       // cellStyle: {
//       //   display: "flex",
//       //   justifyContent: "center",
//       //   alignItems: "center",
//       // },
//       cellRenderer: (p) => (
//         <CardDropdown>
//           <div className="py-2">
//             <Dropdown.Item
//               // as={Link}
//               onClick={() =>
//                 // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
//                 // () =>
//                 handleRowClick(p.data)
//               }
//               // href="/products/add-product"
//               className="d-flex align-items-center gap-2 py-0"
//             >
//               <MdOutlineModeEdit />
//               Edit
//             </Dropdown.Item>
//             {/* <Dropdown.Item
//               // onClick={() => handleDelete()}
//               className="d-flex align-items-center gap-2 py-0"
//             >
//               <MdDeleteOutline />
//               Delete
//             </Dropdown.Item> */}
//           </div>
//         </CardDropdown>
//       ),
//     },
//   ]);

//   const { data: storesData } = useFetchStores();

//   const handleRowClick = (data) => {
//     if (data) {
//       navigate(`${CONSTANT_ROUTES.PRODUCTS_ADD}`, { state: data });
//     }
//   };

//   const defaultColDef = {
//     sortable: true,
//     filter: true,
//     // floatingFilter: true,
//     // flex: 1,
//     // rowDrag: true,
//   };

//   //   ===============Custom Api Call start================

//   let gridApi;
//   let columnApi;

//   // const onGridReady = useCallback(
//   //   (e) => {
//   //     gridApi = e.api;
//   //     columnApi = e.columnApi;
//   //     restoreState();

//   //     ProductsAPI.get().then((res) => {
//   //       e.api.applyTransaction({ add: res?.data?.data?.products });
//   //     });
//   //   },
//   //   [window]
//   // );

//   const [selectedStore, setSelectedStore] = useState(
//     storesData?.data.data[0].id || 2,
//   );
//   const gridApiRef = useRef(null);

//   const loadProducts = (storeId) => {
//     if (!gridApiRef.current) return;

//     // show loader
//     gridApiRef.current.showLoadingOverlay();

//     ProductsAPI.get({ params: { storeId } })
//       .then((res) => {
//         const products = res?.data?.data?.products || [];

//         if (products.length === 0) {
//           // ✅ clear previous store data
//           gridApiRef.current.setRowData([]);

//           // ✅ show no rows overlay
//           gridApiRef.current.showNoRowsOverlay();
//         } else {
//           // ✅ replace old store data
//           gridApiRef.current.setRowData(products);
//         }
//       })
//       .catch(() => {
//         gridApiRef.current.setRowData([]);
//         gridApiRef.current.showNoRowsOverlay();
//       });
//   };

//   // const loadProducts = (storeId) => {
//   //   if (!gridApiRef.current) return;

//   //   gridApiRef.current.setGridOption("loading", true);
//   //   gridApiRef.current.setGridOption("rowData", []);

//   //   ProductsAPI.get({ params: { storeId } })
//   //     .then((res) => {
//   //       gridApiRef.current.applyTransaction({
//   //         add: res?.data?.data?.products || [],
//   //       });
//   //     })
//   //     .finally(() => {
//   //       gridApiRef.current.setGridOption("loading", false);
//   //     });
//   // };

//   const handleStoreChange = (e) => {
//     const storeId = e.target.value || storesData?.data.data[0].id;
//     setSelectedStore(storeId);
//     loadProducts(storeId);
//   };

//   useEffect(() => {
//     const saved = localStorage.getItem("selectedStore");
//     if (saved) setSelectedStore(saved);
//   }, []);

//   useEffect(() => {
//     if (selectedStore) {
//       localStorage.setItem("selectedStore", selectedStore);
//     }
//   }, [selectedStore]);

//   const onGridReady = useCallback((e) => {
//     gridApiRef.current = e.api;
//     columnApiRef.current = e.columnApi;

//     restoreState();
//     loadProducts(selectedStore);
//   }, []);

//   //   ===============Custom Api Call End================

//   const saveState = useCallback(() => {
//     saveColumnState("products", columnApiRef);
//   }, []);

//   const restoreState = useCallback(() => {
//     restoreColumnState("products", columnApiRef);
//   }, []);

//   const resetState = useCallback(() => {
//     resetColumnState("products", columnApiRef);
//   }, []);

//   const onFilterTextBoxChanged = useCallback(() => {
//     columnApiRef.current.api.setGridOption(
//       "quickFilterText",
//       document.getElementById("filter-text-box").value,
//     );
//   }, []);

//   const onRowDoubleClick = (params) => {
//     navigate(`/categories/add-new-category/?id=${params.data?.type}`);
//   };

//   if (isLoading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           width: "100vw",
//           height: "100vh",
//           backgroundColor: "rgba(0, 0, 0, 0.5)", // Backdrop effect
//           zIndex: 9999, // Ensure it's above other content
//         }}
//       >
//         <Spinner variant="primary" animation="border" />
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* <PageTitle name="Categories" /> */}
//       {/* <div className="py-2">
//         <BreadCrumb />
//       </div> */}

//       <PageTitle name="Products" />

//       <div
//         className={`${
//           isDarkBool || isDarkTheme || auto
//             ? "ag-theme-quartz-dark"
//             : "ag-theme-quartz"
//         } rounded-0`} // applying the grid theme
//         // style={{ height: "100vh" }} // the grid will fill the size of the parent container
//       >
//         <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
//           <Card.Header className="d-flex justify-content-between align-items-center">
//             {/* <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
//               Products | Manage Products
//             </h5> */}
//             <BreadCrumbTable title="Products" />
//             <div className="d-flex align-items-center gap-2">
//               {/* Store Dropdown */}
// <Form.Select
//   size="sm"
//   className="rounded-pill"
//   style={{ width: "180px", height: "35px" }}
//   value={selectedStore}
//   onChange={handleStoreChange}
// >
//   <option value="">Select Store</option>

//   {storesData?.data?.data?.map((store) => (
//     <option key={store.id} value={store.id}>
//       {store.businessName}
//     </option>
//   ))}
// </Form.Select>

// <Form
//   className="position-relative"
//   onSubmit={(e) => e.preventDefault()}
// >
//   <FontAwesomeIcon
//     icon="search"
//     className="position-absolute text-400 search-box-icon"
//     style={{
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//     }}
//   />
//   <Form.Control
//     type="search"
//     placeholder="Search..."
//     style={{
//       paddingLeft: "30px",
//     }}
//     aria-label="Search"
//     id="filter-text-box"
//     className="rounded-pill search-input"
//     onInput={onFilterTextBoxChanged}
//   />
// </Form>
//               <OverlayTrigger
//                 overlay={
//                   <Tooltip
//                     style={{ position: "fixed" }}
//                     id="overlay-trigger-example"
//                   >
//                     New
//                   </Tooltip>
//                 }
//               >
//                 <IconButton
//                   variant="falcon-default"
//                   size="sm"
//                   icon="plus"
//                   transform="shrink-3"
//                   onClick={() => navigate(CONSTANT_ROUTES.PRODUCTS_ADD)}
//                 >
//                   <span className="d-none d-sm-inline-block ms-1">New</span>
//                 </IconButton>
//               </OverlayTrigger>
//               <ScreenFeedback />
//               <TableHeaderDropdown>
//                 <div className="py-2">
//                   <Dropdown.Item
//                     onClick={saveState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Save State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={restoreState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Restore State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={resetState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Reset State
//                   </Dropdown.Item>
//                 </div>
//               </TableHeaderDropdown>
//             </div>
//             {/* <div className="test-header">
//               <div className="example-header">
//                 <input
//                   type="text"
//                   id="filter-text-box"
//                   placeholder="Search"
//                   onInput={onFilterTextBoxChanged}
//                 />
//               </div>
//               <div className="example-section">
//                 <button onClick={saveState}>Save State</button>
//                 <button onClick={restoreState}>Restore State</button>
//                 <button onClick={resetState}>Reset State</button>
//               </div>
//             </div> */}
//           </Card.Header>

//           <Card.Body className="p-0">
//             {/* <button onClick={() => onExportClick()}>abc</button> */}

//             <AgGridReact
//               // rowData={rowData}
//               ref={columnApiRef}
//               onGridReady={onGridReady}
//               columnDefs={colDefs}
//               defaultColDef={defaultColDef}
// pagination
// headerHeight={35}
// rowHeight={35}
//               paginationPageSize={settings.paginationSize}
//               onRowDoubleClicked={(params) => handleRowClick(params.data)}
//               overlayNoRowsTemplate="Nothing found - Looks empty over here"
//             />
//           </Card.Body>
//         </Card>
//       </div>
//     </div>
//   );
// }

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { ProductsAPI } from "api";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import CardDropdown from "components/common/CardDropdown";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import { useFetchStores } from "hooks/useFetchStores";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Card,
  Dropdown,
  Form,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import PageTitle from "utils/PageTitle";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "./styles.css";
import ScreenFeedback from "components/feedback/ScreenFeedback";

export default function ProductsTable() {
  const navigate = useNavigate();

  const columnApiRef = useRef(null);
  const gridApiRef = useRef(null);

  const { data: storesData } = useFetchStores();

  const [selectedStore, setSelectedStore] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // ================= Columns =================
  const [colDefs] = useState([
    {
      field: "name",
      headerName: "Name",
      hide: false,
      flex: 7.5,
      cellStyle: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    {
      field: "category",
      headerName: "Category",
      hide: false,
      flex: 1.5,
      cellStyle: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    {
      field: "status",
      headerName: "Active",
      flex: 1.5,
      filter: false,
      sortable: true,
      headerClass: "center-header",
      cellStyle: {
        display: "flex",
        justifyContent: "center",
      },
      cellRenderer: (p) => (
        <Form.Check
          type="checkbox"
          className="mt-1"
          checked={p.value}
          disabled
        />
      ),
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1.5,
      filter: false,

      headerClass: "center-header",
      cellStyle: {
        display: "flex",
        // paddingRight: "30px",
        justifyContent: "center",
      },
      // cellStyle: {
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "center",
      // },
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              // as={Link}
              onClick={() =>
                // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
                // () =>
                handleRowClick(p.data)
              }
              // href="/products/add-product"
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
            {/* <Dropdown.Item
              // onClick={() => handleDelete()}
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdDeleteOutline />
              Delete
            </Dropdown.Item> */}
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const defaultColDef = {
    sortable: true,
    filter: true,
  };

  // ================= Navigation =================
  const handleRowClick = (data) => {
    navigate(CONSTANT_ROUTES.PRODUCTS_ADD, { state: data });
  };

  // ================= Load Products =================
  const loadProducts = useCallback((storeId) => {
    if (!gridApiRef.current || !storeId) return;

    gridApiRef.current.showLoadingOverlay();

    ProductsAPI.get({ params: { storeId } })
      .then((res) => {
        const products = res?.data?.data?.products || [];

        if (products.length === 0) {
          gridApiRef.current.setRowData([]);
          gridApiRef.current.showNoRowsOverlay();
        } else {
          gridApiRef.current.setRowData(products);
        }
      })
      .catch(() => {
        gridApiRef.current.setRowData([]);
        gridApiRef.current.showNoRowsOverlay();
      });
  }, []);

  // ================= Init selected store =================
  // useEffect(() => {
  //   if (storesData?.data?.data?.length) {
  //     const saved = localStorage.getItem("selectedStore");

  //     const defaultStore = saved || storesData.data.data[0].id;

  //     setSelectedStore(defaultStore);
  //   }
  // }, [storesData]);

  useEffect(() => {
    if (storesData?.data?.data?.length) {
      const savedStore = localStorage.getItem("selectedStore");

      const defaultStore = savedStore || storesData.data.data[0].id;

      setSelectedStore(defaultStore);

      // 🔥 IMPORTANT
      localStorage.setItem("selectedStore", defaultStore);
    }
  }, [storesData]);

  // ================= Load data when store changes =================
  useEffect(() => {
    if (selectedStore && gridApiRef.current) {
      loadProducts(selectedStore);
    }
  }, [selectedStore, loadProducts]);

  // ================= Grid Ready =================
  const onGridReady = useCallback(
    (params) => {
      gridApiRef.current = params.api;
      columnApiRef.current = params.columnApi;

      restoreColumnState("products", columnApiRef);

      // 🔥 Important: load here if store already available
      if (selectedStore) {
        loadProducts(selectedStore);
      }
    },
    [selectedStore, loadProducts],
  );

  // ================= Store Change =================
  const handleStoreChange = (e) => {
    const storeId = e.target.value;

    setSelectedStore(storeId);
    localStorage.setItem("selectedStore", storeId);
  };

  // ================= Table State =================
  const saveState = () => saveColumnState("products", columnApiRef);
  const restoreState = () => restoreColumnState("products", columnApiRef);
  const resetState = () => resetColumnState("products", columnApiRef);

  const onFilterTextBoxChanged = () => {
    gridApiRef.current.setQuickFilter(
      document.getElementById("filter-text-box").value,
    );
  };

  // ================= UI =================
  return (
    <div>
      <PageTitle name="Products" />

      <div className="ag-theme-quartz" style={{ height: "100%" }}>
        <Card style={{ height: `calc(100vh - 4rem)` }}>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <BreadCrumbTable title="Products" />

            <div className="d-flex align-items-center gap-2">
              {/* Store Dropdown */}

              <Form.Select
                size="sm"
                className="rounded-pill"
                style={{ width: "180px", height: "35px" }}
                value={selectedStore}
                onChange={handleStoreChange}
              >
                <option value="">Select Store</option>

                {storesData?.data?.data?.map((store) => (
                  <option key={store.id} value={store.id}>
                    {store.businessName}
                  </option>
                ))}
              </Form.Select>

              {/* Search */}

              <Form
                className="position-relative"
                onSubmit={(e) => e.preventDefault()}
              >
                <FontAwesomeIcon
                  icon="search"
                  className="position-absolute text-400 search-box-icon"
                  style={{
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                <Form.Control
                  type="search"
                  placeholder="Search..."
                  style={{
                    paddingLeft: "30px",
                  }}
                  aria-label="Search"
                  id="filter-text-box"
                  className="rounded-pill search-input"
                  onInput={onFilterTextBoxChanged}
                />
              </Form>

              {/* Add */}
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    New
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.PRODUCTS_ADD)}
                >
                  <span className="d-none d-sm-inline-block ms-1">New</span>
                </IconButton>
              </OverlayTrigger>

              <ScreenFeedback />

              {/* Table Settings */}
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header>

          <Card.Body className="p-0">
            <AgGridReact
              onGridReady={onGridReady}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              pagination
              paginationPageSize={settings.paginationSize}
              headerHeight={35}
              rowHeight={35}
              onRowDoubleClicked={(p) => handleRowClick(p.data)}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
